<div class="d-flex" [class.disabled]="isDisabled">
  <button
    type="button"
    class="button button--icon-sm button--primary subtract-button"
    [disabled]="value <= minValue"
    (click)="value = value - step; propagateChanges(value);"
  >
    <i class="ri-subtract-line"></i>
  </button>

  <input
    class="p2 base-border p-0 text-center"
    width="40px"
    type="number"
    height="40px"
    [(ngModel)]="value"
    (ngModelChange)="onValueChange()"
  >

  <button
    type="button"
    class="button button--icon-sm button--primary add-button"
    [disabled]="value >= maxValue"
    (click)="value = value + step; propagateChanges(value);"
  >
    <i class="ri-add-line"></i>
  </button>
</div>
